import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SelectableOption } from '../../components/common/filters/interfaces';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { SERVICES, HttpMethods } from '../../services/api';

export const fetchDropdownOptions: AsyncThunk<{ data: SelectableOption[] }, void, ThunkAPI> = createAsyncThunk(
  'filters/fetchFiltersOptions',
  async (_, thunk) => {
    return apiAsyncThunkCreator < { data: SelectableOption[]}, void> ({
      endpoint: 'lists',
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
